import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import { sidebarToggle } from "./../../utils/toggler.js";
import BottomNavbar from "../BottomNavbar/Index";
import DashboardHeader from "../Other/DashboardHeader";
import { isLeagueCreationPath } from "../../utils/leagueCreationRoutes";

function AuthLayout({ ...props }) {
  const isDesktop = () => document.body.clientWidth > 768;
  const [sidebarStatus, setSidebarStatus] = useState("");
  const token = JSON.parse(localStorage.getItem("accessToken"))
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768); // Adjust the threshold as needed
  const location = useLocation();

    const isTokenAvailable = token !== null && token !== undefined;

  // Auth / landing screens (sign-in, register, verification, etc.) must never
  // show the app's bottom navigation, even when a token already exists — e.g.
  // when the user presses Back after signing in and lands on the "Welcome
  // back" screen. Mirrors PageContainer's hidden-sidebar route list.
  const navHiddenRoutes = [
    "/",
    "/auth/login",
    "/auth/register",
    "/auth/create-account",
    "/auth/verification",
    "/auth/forgot-password",
    "/callback",
  ];
  const hideBottomNav =
    navHiddenRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/auth/register/") ||
    location.pathname.startsWith("/reset-password/") ||
    // Client Rev 1: "Remove the QUSHi logo, the three-dot menu, the League
    // Detail label, and the bottom app navigation during creation." The flow
    // (and its payoff screen) is focused on one task and carries its own header
    // and sticky CTA instead.
    isLeagueCreationPath(location.pathname) ||
    // The Edge: a Read runs as a focused mobile lesson (client: "Hide the main
    // bottom nav while the user is inside a Read"). The nav is mobile-only, so
    // desktop keeps its navigation; it returns as soon as the Read is left.
    location.pathname.startsWith("/edge/");
  useEffect(() => {
    window.addEventListener("resize", () => {
      setSidebarStatus(isDesktop());
    });


    return () => window.removeEventListener("resize", isDesktop);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768); // Adjust the threshold as needed
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Global on-screen-keyboard detector. With interactive-widget=resizes-content
  // the keyboard shrinks the viewport and pushes the fixed bottom nav up into the
  // middle of the screen on every input screen (create post, Edit profile, Reset
  // password, Get help, Watchlist add-asset, …). Watch the visual viewport and
  // hide the nav (body.keyboard-open, see index.css) ONLY while the keyboard is
  // actually up — it drops back to the bottom the instant the keyboard closes.
  // Lives here (the always-mounted layout that owns BottomNavbar) so it covers
  // every screen from one place. Never position:fixed the <body> — that mis-
  // anchors this same nav on iOS.
  useEffect(() => {
    const vv = typeof window !== "undefined" ? window.visualViewport : null;
    // Full (keyboard-down) height as a moving max, so browser-chrome show/hide
    // (small deltas) never registers as a keyboard.
    let baseline = vv ? vv.height : window.innerHeight;
    const check = () => {
      const h = vv ? vv.height : window.innerHeight;
      if (h > baseline) baseline = h;
      const keyboardUp = h < baseline - 150;
      document.body.classList.toggle("keyboard-open", keyboardUp);
    };
    check();
    const target = vv || window;
    target.addEventListener("resize", check);
    return () => {
      target.removeEventListener("resize", check);
      document.body.classList.remove("keyboard-open");
    };
  }, []);

  return (
    <div className="adminLayout" style={{height:"auto"}}>
      {/* Sidebar */}
      <Sidebar
        toggle={sidebarToggle}
        className={sidebarStatus ? "" : "mobile"}
      />

      {/* Main Wrapper */}
      <div className={isMobileView ? "mainWrapper bg-white !pb-0" : "mainWrapper"}>
        {/* <DashboardHeader/> */}
        <Outlet context={[sidebarToggle]} />
      </div>

      {/* Bottom Navigation */}
      {isTokenAvailable && !hideBottomNav && <BottomNavbar />}
    </div>
  );
}

export default AuthLayout;
